var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', {
          staticClass: "uppercase"
        }, [_vm._v("HISTORY SERVICE & REPAIR - " + _vm._s(_vm.fleets))])])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('a', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse-filter",
            modifiers: {
              "collapse-filter": true
            }
          }],
          staticClass: "text-primary float-right",
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "role": "button"
          }
        }, [_c('i', {
          staticClass: "fa fa-calendar"
        })])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$list_repair_finis, _vm$list_repair_finis2;
        return [_c('b-collapse', {
          staticClass: "mb-2",
          attrs: {
            "id": "collapse-filter"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('date-picker', {
          attrs: {
            "lang": _vm.lang,
            "type": "date",
            "range": "",
            "placeholder": "Select date range"
          },
          model: {
            value: _vm.dateRange,
            callback: function callback($$v) {
              _vm.dateRange = $$v;
            },
            expression: "dateRange"
          }
        })], 1), _c('b-col', {
          attrs: {
            "md": "5"
          }
        })], 1)], 1), _c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('th', [_vm._v("Loaction")]), _c('th', [_vm._v("Accident Date")]), _c('th', [_vm._v("Actual Start Date")]), _c('th', [_vm._v("Actual Finish Date")]), _c('th', [_vm._v("Total Days")]), _c('th', [_vm._v("Total Item Repair")]), _c('th', [_vm._v("Pic")]), _c('th', [_vm._v("Action")])]), _c('tbody', [_vm.list_repair_finished.data ? _vm._l(_vm.list_repair_finished.data, function (item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(item.location))]), _c('td', [_vm._v(_vm._s(_vm.toFormatDate(item.accident_at)))]), _c('td', [_vm._v(_vm._s(item !== null && item !== void 0 && item.start_date_real ? _vm.toFormatDate(item === null || item === void 0 ? void 0 : item.start_date_real) : '-'))]), _c('td', [_vm._v(_vm._s(item !== null && item !== void 0 && item.finish_date_real ? _vm.toFormatDate(item === null || item === void 0 ? void 0 : item.finish_date_real) : '-'))]), _c('td', [_vm._v(" " + _vm._s(_vm.totalDays(item.start_date_real, item.finish_date_real)) + " Days ")]), _c('td', [_vm._v(_vm._s(item.total_repair) + " Repair")]), _c('td', {
            staticClass: "d-flex flex-column"
          }, [_c('p', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(item.pic))])]), _c('td', [_c('b-dropdown', {
            attrs: {
              "text": "Action",
              "size": "sm",
              "variant": "outline-primary"
            }
          }, [_c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleAction(item, 'detail');
              }
            }
          }, [_vm._v("Detail Service & Repair")])], 1)], 1)]);
        }) : _vm._e()], 2)]), ((_vm$list_repair_finis = _vm.list_repair_finished) === null || _vm$list_repair_finis === void 0 ? void 0 : (_vm$list_repair_finis2 = _vm$list_repair_finis.data) === null || _vm$list_repair_finis2 === void 0 ? void 0 : _vm$list_repair_finis2.length) > 0 ? _c('div', {
          staticClass: "mt-3"
        }, [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.list_repair_finished.meta.total_item,
            "per-page": _vm.list_repair_finished.meta.per_page,
            "aria-controls": "my-table",
            "align": "center",
            "first-number": ""
          },
          on: {
            "change": _vm.getListFinishedTableServiceAndRepairById
          },
          model: {
            value: _vm.list_repair_finished.meta.page,
            callback: function callback($$v) {
              _vm.$set(_vm.list_repair_finished.meta, "page", $$v);
            },
            expression: "list_repair_finished.meta.page"
          }
        })], 1) : _vm._e()];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }